import { theme } from '../../electrons/Theme/Theme.constants';
export const StyledComponent = () => {
    return {
        border: 0,
        borderRadius: 8,
        '& .MuiDataGrid-main': {
            borderRadius: 8,
            border: 0,
            backgroundColor: 'white',
        },
        '& .MuiDataGrid-columnHeader': {
            backgroundColor: theme.colors.gray[100],
            borderRight: '1px solid white',
            outline: '0 !important',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
            fontSize: theme.typography.label.fontSize,
            fontWeight: theme.typography.label.fontWeight,
            fontStyle: 'normal',
            color: theme.colors.gray[800],
            textTransform: theme.typography.label.textTransform,
            fontFamily: 'Source Sans Pro',
        },
        '& .MuiDataGrid-cell--withRenderer': {
            outline: '0 !important',
        },
        '& .MuiDataGrid-cell--textLeft': {
            fontFamily: 'Source Sans Pro',
            fontSize: theme.typography.body2.fontSize,
            fontWeight: theme.typography.body2.fontSize,
            letterSpacing: theme.typography.body2.letterSpacing,
            color: theme.colors.gray[900],
        },
        '& .MuiDataGrid-iconButtonContainer': {
            visibility: 'visible',
        },
        '& .MuiDataGrid-row:nth-child(even)': {
            backgroundColor: theme.colors.gray[0],
        },
        '& .MuiDataGrid-row:nth-child(odd)': {
            backgroundColor: theme.colors.primary.contrastWhite,
        },
        '& .MuiTablePagination-root': {
            marginLeft: 'auto',
            marginRight: 'auto',
            '.MuiTablePagination-toolbar': {
                marginTop: theme.spacing(1),
                display: 'flex',
                alignItems: 'baseline',
                '.MuiTablePagination-select': {
                    backgroundColor: theme.colors.primary.contrastWhite,
                    borderColor: theme.colors.gray[200],
                    borderRadius: theme.spacing(1),
                    borderStyle: 'solid',
                    borderWidth: '1px',
                },
            },
        },
        '& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus': {
            outline: 'none !important',
        },
        '& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus': {
            outline: 'none !important',
        },
        '& .MuiDataGrid-cell--pinnedRight, & .MuiDataGrid-cell--pinnedLeft': {
            background: 'inherit',
        },
    };
};
export const DataGridStyles = {
    StyledComponent,
};
//# sourceMappingURL=DataGrid.styles.js.map